import { Platform, StyleSheet } from 'react-native';
import { COLORS, SPACING, theme, TYPE_CONFIG } from '@garnish/constants';
import {
  FIELD_HEIGHT,
  FLOATING_LABEL_OFFSET,
  SUBMIT_BUTTON_SIZE,
} from './TextField.constants';

export const styles = StyleSheet.create({
  containerWithLabel: {
    paddingTop: FLOATING_LABEL_OFFSET,
  },

  // ─── WRAPPER ────────────────────────────────────────────────────────

  wrapper: {
    position: 'relative',
    width: '100%',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: COLORS.GRAY,
  },

  multilineWrapper: {
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    borderRadius: theme.radius.small,
    padding: theme.spacing.small,
  },

  wrapperActive: {
    borderBottomColor: theme.colors.TEXT_COLOR,
  },

  multilineWrapperActive: {
    borderTopColor: COLORS.TEXT_COLOR,
    borderColor: COLORS.TEXT_COLOR,
  },

  multilineWrapperDisabled: {
    borderColor: COLORS.GRAY,
  },

  multilineWrapperInvalid: {
    borderColor: COLORS.CAUTION,
  },

  wrapperInvalid: {
    borderBottomColor: COLORS.CAUTION,
  },

  wrapperDisabled: {
    borderBottomColor: COLORS.GRAY,

    // see: https://github.com/facebook/react-native/issues/24224
    // NOTE: On iOS, `borderStyle`s other than `solid` do not work properly.
    //       There are some hacky workarounds, but those add too much complexity.
    borderStyle: Platform.select({ default: 'dashed', ios: 'solid' }),

    // So we modify the `opacity` on `iOS` to make it appear disabled.
    opacity: Platform.select({ default: 1, ios: 0.6 }),
  },

  // ─── INPUT ──────────────────────────────────────────────────────────

  input: {
    minWidth: 0,
    flexShrink: 1,
    flexGrow: 1,
    borderWidth: 0,
    borderRadius: 0,
    height: FIELD_HEIGHT,
    color: COLORS.TEXT_COLOR,
    ...TYPE_CONFIG.BODY['16'],
    fontWeight: 'normal',
  },

  // ─── LABEL ──────────────────────────────────────────────────────────

  labelWrapper: {
    position: 'absolute',
    top: '50%',
    alignSelf: 'flex-start',
    maxWidth: '100%',
  },
  label: {
    lineHeight: 16,
  },

  // ─── CTA ────────────────────────────────────────────────────────────

  ctaWrapper: {
    flexShrink: 0,
    justifyContent: 'center',
    paddingLeft: SPACING.small,
    ...(Platform.OS === 'web' && { userSelect: 'none' }),
  },
  textCtaWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  textCtaContent: {
    letterSpacing: 1,
    color: COLORS.CHARCOAL,
    textTransform: 'uppercase',
  },
  submitButton: {
    width: SUBMIT_BUTTON_SIZE,
    height: SUBMIT_BUTTON_SIZE,
    paddingVertical: 0,
    paddingHorizontal: 0,
  },

  // ─── HELPER TEXT ────────────────────────────────────────────────────

  helperText: {
    color: COLORS.CHARCOAL,
    paddingTop: SPACING.small,
  },

  // ─── NOTICE ─────────────────────────────────────────────────────────

  noticeWrapper: {
    paddingTop: SPACING.small,
    minHeight: SPACING.large,
  },
});
